module.exports = __webpack_public_path__ + "static/media/tutorial-4.98650af2.jpg";